function view (path) {
  return () => import(/* webpackChunkName: 'audit-v1' */ '@/views/audit/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAudit = [
  {
    path: '/audit/dashboard',
    component: view('Dashboard'),
    name: 'audit.dashboard',
    authorizedRole: 'audit'
  },
  {
    path: '/audit/inventory-transfers',
    component: view('transfers/Base'),
    name: 'audit.inventory-transfers',
    authorizedRole: 'audit',
    meta: {
      breadcrumb: [
        {
          text: 'Audit'
        },
        {
          text: 'Transfers',
          active: true
        }
      ]
    }
  }
]

export default RAudit
